module.exports = __webpack_public_path__ + "static/media/approach-concept.dc8d1f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-concept.jpg
// module id = 137
// module chunks = 0